import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { MessageSquareReply } from "lucide-react";
import { Rating, ReviewItem } from "@/components/marketplace/Reviews";

export function SellerReviews({ seller }) {
  const [items, setItems] = useState(null);
  const [replying, setReplying] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/reviews/received").then(r => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const send = async (rv) => {
    setBusy(true);
    try { await api.post(`/reviews/${rv.id}/reply`, { text }); toast.success("Resposta publicada"); setReplying(null); setText(""); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const now = new Date().toISOString();
  return (
    <div data-testid="seller-reviews" className="space-y-2 mb-8">
      <div className="bg-white rounded-2xl border border-zinc-200 p-3 flex items-center justify-between">
        <div><div className="font-semibold text-sm">Avaliações da loja</div><div className="text-[11px] text-zinc-500">Média global de produtos, serviços e reservas. Podes responder uma vez a cada avaliação.</div></div>
        {seller.rating_count ? <Rating avg={seller.rating_avg} count={seller.rating_count} size="lg" testid="seller-reviews-rating" /> : <span className="text-[11px] text-zinc-400">Sem avaliações</span>}
      </div>
      {items?.length === 0 && <p data-testid="seller-reviews-empty" className="text-sm text-zinc-500 text-center py-8">Ainda não recebeste avaliações.</p>}
      {items?.map(rv => (
        <ReviewItem key={rv.id} rv={rv}>
          {rv.status === "hidden" && <div className="mt-1 text-[10px] font-semibold text-orange-700">Oculta pela moderação — não é pública.</div>}
          {replying === rv.id ? (
            <div className="mt-2 space-y-1.5">
              <textarea data-testid={`reply-text-${rv.id}`} value={text} onChange={e => setText(e.target.value.slice(0, 1000))} rows={3} placeholder="Escreve a tua resposta pública…" className="w-full px-3 py-2 rounded-xl border border-zinc-200 bg-zinc-50 text-xs outline-none focus:border-black resize-none" />
              <div className="flex gap-2"><button onClick={() => setReplying(null)} className="flex-1 py-2 rounded-xl border border-zinc-200 text-xs font-semibold">Cancelar</button>
                <button data-testid={`reply-submit-${rv.id}`} onClick={() => send(rv)} disabled={busy || !text.trim()} className="flex-1 py-2 rounded-xl bg-black text-white text-xs font-semibold disabled:opacity-50">{busy ? "A enviar…" : rv.seller_reply ? "Guardar" : "Publicar resposta"}</button></div>
            </div>
          ) : (
            <div className="mt-2 flex justify-end">
              {!rv.seller_reply && rv.status === "published" && <button data-testid={`reply-btn-${rv.id}`} onClick={() => { setReplying(rv.id); setText(""); }} className="inline-flex items-center gap-1 text-[11px] font-semibold px-2.5 py-1 rounded-full border border-zinc-300 hover:border-black"><MessageSquareReply size={11} /> Responder</button>}
              {rv.seller_reply && rv.seller_reply.edit_until >= now && <button data-testid={`reply-edit-${rv.id}`} onClick={() => { setReplying(rv.id); setText(rv.seller_reply.text); }} className="text-[11px] font-semibold underline">Editar resposta</button>}
            </div>
          )}
        </ReviewItem>
      ))}
    </div>
  );
}
